module.exports = __webpack_public_path__ + "img/empty.402ab0df.svg";